import * as React from 'react';
import styled from 'styled-components';
import { FlexColCenter } from '../../../Defaults/Flexbox/Flexbox';
import { OptionChooserItem } from './OptionChooserItem';

const Wrapper = styled(FlexColCenter)`
  width: 100%;
`;

interface Props {
  items: any[];
  selectedOption: any;
  isCartUpdating?: boolean;
  zasielkovnaPayload?: any;
  handleOptionClick: (option: any) => void;
}

function OptionChooser({
  items,
  selectedOption,
  handleOptionClick,
  zasielkovnaPayload,
}: Props) {
  return (
    <Wrapper>
      {items &&
        items.map(item => {
          return (
            <OptionChooserItem
              zasielkovnaPayload={zasielkovnaPayload}
              key={item.id}
              item={item}
              selected={selectedOption ? selectedOption.id === item.id : false}
              pictures={item.icons ? item.icons : []}
              // tslint:disable-next-line:jsx-no-lambda
              handleOptionClick={() => handleOptionClick(item.id)}
            />
          );
        })}
    </Wrapper>
  );
}

export default OptionChooser;
